var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogicApi = function SvgIconLogicApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_logic_api_svg2__a",
    x1: 67.64,
    x2: 515.64,
    y1: 530.13,
    y2: 120.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_logic_api_svg2__a",
    id: "icon_logic_api_svg2__b",
    x1: 18.21,
    x2: 466.21,
    y1: 476.12,
    y2: 66.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_logic_api_svg2__a",
    id: "icon_logic_api_svg2__c",
    x1: 34.67,
    x2: 482.67,
    y1: 494.1,
    y2: 84.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_logic_api_svg2__a",
    id: "icon_logic_api_svg2__d",
    x1: 16.97,
    x2: 464.97,
    y1: 474.76,
    y2: 64.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_logic_api_svg2__a",
    id: "icon_logic_api_svg2__e",
    x1: 33.42,
    x2: 481.42,
    y1: 492.73,
    y2: 82.73
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_logic_api_svg2__a",
    id: "icon_logic_api_svg2__f",
    x1: 15.72,
    x2: 463.72,
    y1: 473.39,
    y2: 63.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_logic_api_svg2__a",
    id: "icon_logic_api_svg2__g",
    x1: 32.17,
    x2: 480.17,
    y1: 491.37,
    y2: 81.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_logic_api_svg2__a",
    id: "icon_logic_api_svg2__h",
    x1: 127.24,
    x2: 575.24,
    y1: 595.26,
    y2: 185.26
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M330.32 90.84v66.06c0 13.66 11.12 24.77 24.77 24.77h132.13c13.66 0 24.77-11.12 24.77-24.77V90.84c0-13.66-11.12-24.77-24.77-24.77h-33.25c5.24-6.92 8.47-15.44 8.47-24.77 0-22.77-18.52-41.29-41.29-41.29-19.93 0-36.62 14.21-40.46 33.03h-91.67c-22.77 0-41.29 18.52-41.29 41.29v75.16c-16.15 3.29-28.9 16.05-32.2 32.2h-91.67c-22.77 0-41.29 18.52-41.29 41.29v75.16c-18.82 3.84-33.03 20.52-33.03 40.46 0 9.33 3.23 17.85 8.47 24.77H24.77C11.11 363.37 0 374.49 0 388.14v66.06c0 13.66 11.12 24.77 24.77 24.77H156.9c13.66 0 24.77-11.12 24.77-24.77v-66.06c0-13.66-11.12-24.77-24.77-24.77h-33.25c5.24-6.92 8.47-15.44 8.47-24.77 0-19.93-14.21-36.62-33.03-40.46v-75.16c0-13.66 11.12-24.77 24.77-24.77h91.67c1.26 6.14 3.98 11.69 7.63 16.52h-33.24c-13.66 0-24.77 11.12-24.77 24.77v66.06c0 13.66 11.12 24.77 24.77 24.77h65.07c-.52 1.46-1.07 2.91-1.54 4.39l-22.25 5.72v62.36l22.25 5.71c2.22 7.13 5.07 14.02 8.51 20.58l-11.69 19.75 44.1 44.1 19.75-11.68c6.57 3.44 13.46 6.29 20.59 8.51l5.71 22.24h62.36l5.71-22.24c7.13-2.22 14.01-5.07 20.59-8.51l19.75 11.68 44.1-44.1-11.69-19.75a123.6 123.6 0 0 0 8.51-20.58l22.25-5.72v-62.36l-22.25-5.71c-2.22-7.13-5.07-14.02-8.51-20.58l11.69-19.74-44.1-44.1-19.75 11.69c-6.56-3.44-13.45-6.28-20.59-8.51l-5.71-22.25H345.3c-3.42-9.59-12.5-16.52-23.25-16.52H288.8c5.24-6.92 8.47-15.44 8.47-24.77 0-19.93-14.21-36.62-33.03-40.46V74.32c0-13.66 11.12-24.77 24.77-24.77h91.67c1.26 6.14 3.98 11.69 7.63 16.52h-33.24c-13.66 0-24.77 11.12-24.77 24.77ZM156.9 379.87c4.55 0 8.26 3.7 8.26 8.26v66.06c0 4.56-3.71 8.26-8.26 8.26H24.77c-4.55 0-8.26-3.7-8.26-8.26v-66.06c0-4.56 3.71-8.26 8.26-8.26zm-41.29-41.29c0 13.66-11.12 24.77-24.77 24.77s-24.77-11.12-24.77-24.77 11.12-24.77 24.77-24.77 24.77 11.12 24.77 24.77m231.23-90.84h43.14l4.9 19.08 4.65 1.25c9 2.42 17.61 5.98 25.58 10.57l4.18 2.41 16.92-10.02 25.98 25.98-10.01 16.94 2.41 4.18c4.59 7.95 8.15 16.56 10.57 25.58l1.26 4.65 19.07 4.89v36.74l-19.07 4.9-1.26 4.65c-2.42 9.02-5.99 17.62-10.57 25.58l-2.41 4.18 10.01 16.94-25.98 25.97-16.92-10.01-4.18 2.41c-7.98 4.6-16.58 8.16-25.58 10.57l-4.66 1.25-4.9 19.08h-36.73l-4.9-19.08-4.66-1.25c-8.99-2.41-17.6-5.98-25.58-10.57l-4.18-2.41L297 472.21l-25.98-25.97 10.01-16.94-2.41-4.18c-4.59-7.95-8.15-16.56-10.57-25.58l-1.26-4.65-19.07-4.89v-36.74l19.07-4.9 1.26-4.65c1.23-4.58 2.86-9.03 4.67-13.37h17.97c-6.51 12.68-9.93 26.71-9.93 41.28 0 50.09 40.75 90.84 90.84 90.84s90.84-40.75 90.84-90.84-40.75-90.84-90.84-90.84c-8.48 0-16.76 1.25-24.77 3.52v-36.55Zm0 57.81v-3.95c7.93-2.81 16.23-4.31 24.77-4.31 40.98 0 74.32 33.34 74.32 74.32s-33.35 74.32-74.32 74.32-74.32-33.34-74.32-74.32c0-14.89 4.37-29.06 12.58-41.29h12.2c13.66 0 24.77-11.12 24.77-24.77m-24.78-74.32c4.55 0 8.26 3.71 8.26 8.26v66.06c0 4.56-3.71 8.26-8.26 8.26H189.93c-4.55 0-8.26-3.7-8.26-8.26v-66.06c0-4.55 3.71-8.26 8.26-8.26zm-41.29-41.29c0 13.66-11.12 24.77-24.77 24.77s-24.77-11.12-24.77-24.77 11.12-24.77 24.77-24.77 24.77 11.12 24.77 24.77M421.16 16.52c13.66 0 24.77 11.12 24.77 24.77s-11.12 24.77-24.77 24.77-24.77-11.12-24.77-24.77 11.12-24.77 24.77-24.77m66.07 66.06c4.55 0 8.26 3.71 8.26 8.26v66.06c0 4.55-3.71 8.26-8.26 8.26H355.1c-4.55 0-8.26-3.71-8.26-8.26V90.84c0-4.55 3.71-8.26 8.26-8.26z",
    style: {
      fill: "url(#icon_logic_api_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.35 99.1h115.61v16.52H363.35z",
    style: {
      fill: "url(#icon_logic_api_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.35 132.13h115.61v16.52H363.35z",
    style: {
      fill: "url(#icon_logic_api_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.19 247.74H313.8v16.52H198.19z",
    style: {
      fill: "url(#icon_logic_api_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.19 280.77H313.8v16.52H198.19z",
    style: {
      fill: "url(#icon_logic_api_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.03 396.39h115.61v16.52H33.03z",
    style: {
      fill: "url(#icon_logic_api_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.03 429.42h115.61v16.52H33.03z",
    style: {
      fill: "url(#icon_logic_api_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.61 412.9c22.77 0 41.29-18.52 41.29-41.29s-18.52-41.29-41.29-41.29-41.29 18.52-41.29 41.29 18.52 41.29 41.29 41.29m0-66.06c13.66 0 24.77 11.12 24.77 24.77s-11.12 24.77-24.77 24.77-24.77-11.12-24.77-24.77 11.12-24.77 24.77-24.77",
    style: {
      fill: "url(#icon_logic_api_svg2__h)"
    }
  }));
};
export default SvgIconLogicApi;